import { transactionService } from "@/common/api.service";

/**
 * Transaction statement store module (namespaced as `statement`).
 *
 * Talks to the arch backend (`/api/v1`) which proxies mobapp_service_python's CE
 * statement endpoints. Generation (and the PDF/Excel template) lives in the mobile
 * service, so CE-generated statements are identical to the ones customers receive.
 *
 * Actions resolve with the raw axios response (success OR error response), following
 * the holds/transaction module convention, so components branch on `response.status`
 * without a try/catch.
 */
const state = {
  loading: false,
};

const getters = {
  statementLoading(state) {
    return state.loading;
  },
};

const SET_LOADING = "SET_LOADING";

const mutations = {
  [SET_LOADING](state, value) {
    state.loading = value;
  },
};

const actions = {
  // POST /api/v1/payment/statement/request
  async requestStatement(context, payload = {}) {
    transactionService.init();
    context.commit(SET_LOADING, true);
    return new Promise((resolve) => {
      transactionService
        .post("payment/statement/request", payload)
        .then((data) => {
          context.commit(SET_LOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_LOADING, false);
          resolve(response);
        });
    });
  },

  // GET /api/v1/payment/statement/list?customer_id=...
  async listStatements(context, customerId) {
    transactionService.init();
    context.commit(SET_LOADING, true);
    return new Promise((resolve) => {
      transactionService
        .get(`payment/statement/list?customer_id=${encodeURIComponent(customerId)}`)
        .then((data) => {
          context.commit(SET_LOADING, false);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_LOADING, false);
          resolve(response);
        });
    });
  },

  // GET /api/v1/payment/statement/check?statement_id=...&customer_id=...
  async checkStatement(_context, { statementId, customerId } = {}) {
    transactionService.init();
    return new Promise((resolve) => {
      transactionService
        .get(
          `payment/statement/check?statement_id=${encodeURIComponent(
            statementId,
          )}&customer_id=${encodeURIComponent(customerId)}`,
        )
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // GET /api/v1/payment/statement/customer-search?q=...
  async searchCustomers(_context, q) {
    transactionService.init();
    return new Promise((resolve) => {
      transactionService
        .get(`payment/statement/customer-search?q=${encodeURIComponent(q)}`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },

  // GET /api/v1/payment/statement/beneficiary-search?customer_id=...&q=...
  async searchBeneficiaries(_context, { customerId, q } = {}) {
    transactionService.init();
    const query = `customer_id=${encodeURIComponent(customerId)}${
      q ? `&q=${encodeURIComponent(q)}` : ""
    }`;
    return new Promise((resolve) => {
      transactionService
        .get(`payment/statement/beneficiary-search?${query}`)
        .then((data) => resolve(data))
        .catch(({ response }) => resolve(response));
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
